export default "__VITE_ASSET__lBx27ojz__"